import React, { useState } from 'react';
import ConsultationModal from '../../components/ConsultationModal';
import img2 from '../../img/2.png';

function HairAnalysis() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <section className="page-hero">
        <div className="absolute inset-0 z-0">
          <img
            src={img2}
            alt="Hair replacement consultation"
            className="h-full w-full object-cover object-top opacity-40"
          />
          <div className="page-hero-scrim" />
        </div>
        <div className="container relative z-10 mx-auto px-4">
          <p className="section-kicker text-primary-200">Start here</p>
          <h1 className="font-display text-5xl font-semibold md:text-6xl">
            Hair Replacement Consultation
          </h1>
          <p className="mt-5 max-w-2xl text-xl text-white/85">
            A private appointment to understand your coverage needs, lifestyle, and goals before recommending a custom hair system.
          </p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid gap-12 md:grid-cols-2">
            <div>
              <p className="section-kicker">Consultation focus</p>
              <h2 className="section-heading">What we cover in your visit</h2>
              <div className="space-y-6">
                {[
                  {
                    title: 'Coverage Goals',
                    copy: 'Review the areas you want covered and the finished look you want to achieve.',
                  },
                  {
                    title: 'System Options',
                    copy: 'Discuss base options, density, color, texture, and attachment preferences.',
                  },
                  {
                    title: 'Maintenance Planning',
                    copy: 'Map out appointment timing and home care expectations before you begin.',
                  },
                ].map((item) => (
                  <div key={item.title} className="border-t border-primary-100 pt-5">
                    <h3 className="font-display text-2xl font-semibold text-ink">{item.title}</h3>
                    <p className="mt-2 text-ink-muted">{item.copy}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-surface p-8">
              <h2 className="font-display text-3xl font-semibold text-ink">What to expect</h2>
              <ul className="mt-6 space-y-3 text-ink-muted">
                <li>Private hair replacement discussion</li>
                <li>System recommendation</li>
                <li>Fit and maintenance overview</li>
                <li>Next-step appointment guidance</li>
              </ul>
              <p className="mt-6 text-sm text-ink-muted">
                Free consultation. No pressure to decide on the spot.
              </p>
              <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                className="mt-8 w-full rounded-full bg-primary-600 px-6 py-3 font-semibold text-white transition duration-300 hover:bg-primary-700"
              >
                Schedule Consultation
              </button>
            </div>
          </div>
        </div>
      </section>

      <ConsultationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        interest="Hair Replacement Consultation"
      />
    </div>
  );
}

export default HairAnalysis;
